const IPV4_REGEX = /^(\d{1,3}\.){3}\d{1,3}$/;

const parseIpv4 = ip => {
  if (!IPV4_REGEX.test(ip)) return null;
  const parts = ip.split('.').map(Number);
  if (parts.some(part => part > 255)) return null;
  return parts.reduce((acc, octet) => ((acc << 8) + octet) >>> 0, 0);
};

const ipv4InCidr = (ip, cidr) => {
  const [network, prefixLength] = cidr.split('/');
  const ipInt = parseIpv4(ip);
  const networkInt = parseIpv4(network);
  const bits = Number(prefixLength);

  if (ipInt === null || networkInt === null || Number.isNaN(bits)) return false;
  if (bits < 0 || bits > 32) return false;
  if (bits === 0) return true;

  const mask = bits === 32 ? 0xffffffff : (~0 << (32 - bits)) >>> 0;
  return (ipInt & mask) === (networkInt & mask);
};

/**
 * Returns true when `ip` matches an exact address or IPv4 CIDR in `allowlist`.
 * IPv6 entries are exact-match only.
 */
export const isIpInAllowlist = (ip, allowlist = []) => {
  const clientIp = String(ip || '').trim();
  if (!clientIp) return false;

  return allowlist.some(entry => {
    const rule = String(entry || '').trim();
    if (!rule) return false;

    if (rule.includes('/')) {
      // CIDR matching implemented for IPv4; IPv6 CIDRs fall back to exact match.
      if (clientIp.includes(':') || rule.includes(':')) {
        return clientIp === rule;
      }
      return ipv4InCidr(clientIp, rule);
    }

    return clientIp === rule;
  });
};
